import {
  SET_ACTIVE_COMPANY,
  SET_COMPANY,
  SET_USER_COMPANIES,
} from "../actions/CompanyActions";

const initialState = {
  userCompanies: [],
  activeCompany: null,
  company: null,
  meta: {},
};

const CompanyReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_COMPANIES:
      return {
        ...state,
        userCompanies: action.payload.data,
        meta:action.payload.meta,
        activeCompany: action.payload.data.length > 0 ? action.payload.data[0] : null,
      };

    case SET_ACTIVE_COMPANY:
      return {
        ...state,
        activeCompany: action.payload,
      };

    case SET_COMPANY:
      return {
        ...state,
        company: action.payload,
      };

    default:
      return state;
  }
};

export default CompanyReducer;
